export default __webpack_public_path__ + "static/es-flag.img-b17898ee558cf1654eef71836f2e57c8.svg";